import { createFileRoute, Link } from '@tanstack/react-router';
import { useVendorCenter } from '../../hooks/useBills';
import { useActiveCompanyId } from '../../stores/useCompanyStore';
import { formatCurrency } from '../../lib/formatters';

export const Route = createFileRoute('/_auth/vendor-center/')({
  component: VendorCenterPage,
});

function VendorCenterPage() {
  const companyId = useActiveCompanyId();
  const { data, isLoading, error } = useVendorCenter(companyId);

  if (!companyId) {
    return (
      <div className="card" style={{ textAlign: 'center', padding: 32 }}>
        <h1 style={{ marginTop: 0 }}>Vendor Center</h1>
        <p className="muted">No active company.</p>
        <Link to="/companies" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          Go to Companies
        </Link>
      </div>
    );
  }

  const rows = data?.rows ?? [];
  const totals = data?.totals;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h1 style={{ fontSize: 24, margin: 0 }}>Vendor Center</h1>
          <p className="muted" style={{ margin: '4px 0 0', fontSize: 13 }}>
            Payables by vendor — outstanding and past-due balances
          </p>
        </div>
        <div style={{ display: 'flex', gap: 12 }}>
          <Link to="/reports/ap-aging" className="btn-secondary" style={{ textDecoration: 'none' }}>A/P aging</Link>
          <Link to="/bills/new" className="btn-primary" style={{ textDecoration: 'none' }}>+ New bill</Link>
        </div>
      </div>

      {isLoading && <p className="muted">Loading…</p>}
      {error && <p className="field-error">Failed to load vendor center.</p>}

      {!isLoading && rows.length === 0 && (
        <div className="card" style={{ textAlign: 'center', padding: 32 }}>
          <p className="muted" style={{ marginTop: 0 }}>No vendors yet.</p>
          <Link to="/vendors" className="btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
            Add a vendor
          </Link>
        </div>
      )}

      {rows.length > 0 && (
        <table className="table">
          <thead>
            <tr>
              <th>Vendor</th>
              <th style={{ textAlign: 'right' }}>Bills</th>
              <th style={{ textAlign: 'right' }}>Open</th>
              <th style={{ textAlign: 'right' }}>Billed</th>
              <th style={{ textAlign: 'right' }}>Outstanding</th>
              <th style={{ textAlign: 'right' }}>Past due</th>
              <th style={{ width: 1 }}></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.vendorId}>
                <td style={{ fontWeight: 500 }}>{r.name}</td>
                <td style={{ textAlign: 'right' }}>{r.billCount}</td>
                <td style={{ textAlign: 'right' }}>{r.openCount}</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(r.totalBilled)}</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(r.outstanding)}</td>
                <td style={{ textAlign: 'right', color: parseFloat(r.overdue) > 0 ? 'var(--bad)' : undefined }}>
                  {formatCurrency(r.overdue)}
                </td>
                <td>
                  <Link to="/vendor-center/$id" params={{ id: r.vendorId }} className="btn-secondary" style={{ textDecoration: 'none' }}>
                    View
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
          {totals && (
            <tfoot>
              <tr style={{ fontWeight: 700, borderTop: '2px solid var(--border)' }}>
                <td>Totals</td>
                <td style={{ textAlign: 'right' }}>{totals.billCount}</td>
                <td></td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(totals.totalBilled)}</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(totals.outstanding)}</td>
                <td style={{ textAlign: 'right' }}>{formatCurrency(totals.overdue)}</td>
                <td></td>
              </tr>
            </tfoot>
          )}
        </table>
      )}
    </div>
  );
}
